// Initiate search context
import { createContext } from "react";

const logSearchContext = createContext();

export default logSearchContext;
